import { createAction, props } from '@ngrx/store';

export const setLoading = createAction(
    '[Loading] Set Loading',
    props<{ key: string; loading: boolean }>()
);

export const clearAllLoading = createAction('[Loading] Clear All Loading');